import AppContext from "./AppContext";
import { useBackend, useSession } from "../../hooks";
import { CommonCalls as Calls } from "../../../config/calls";

function AppContextProvider({ children }) {
  const { session } = useSession();
  const { data, feedback, updateData, fetch } = useBackend(
    Calls.appLoad,
    [session.authenticated],
    session.authenticated,
  );

  function updateUserData(newUserData) {
    updateData(newUserData);
  }

  function reload() {
    return fetch();
  }

  const contextValue = {
    data,
    feedback,
    updateUserData,
    reload,
  };

  return (
    <AppContext.Provider value={contextValue}>
      {typeof children === "function" ? children(contextValue) : children}
    </AppContext.Provider>
  );
}

export default AppContextProvider;
